import React from 'react';
import ExcalidrawBpmnEditor from '../../component/excalidraw-bpmn/ExcalidrawBpmnEditor';

const ExcalidrawEditorPage = () => {
  return <ExcalidrawBpmnEditor />;
};

export default ExcalidrawEditorPage;